import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Loader, Nav } from 'rsuite'
import { useRoom } from '../../context/rooms.context'
import RoomItems from './RoomItems'


const ChatRoomList = ({aboveElHeight}) => {
    const rooms = useRoom();
    const location = useLocation();
    return (
        <Nav 
        appearance="subtle"
        vertical
        reversed
        className="overflow-y-scroll custom-scroll"
        style={{
            height: `calc(100% - ${aboveElHeight}px)`
        }}
        activeKey={location.pathname}
        >
            {!rooms && (
                <Loader center vertical content="Loading" speed="low" size="md" />
            )}
            {rooms &&
            rooms.length > 0 &&
            rooms.map (room => (
                <Nav.Item componentClass={Link} to={`/chat/${room.id}`} key={rooms.id} eventKey={`/chat/${room.id}`}>
                <RoomItems room={room} />
            </Nav.Item>
            ))}
      
        </Nav>
            
        
    )
}

export default ChatRoomList
